module.exports = __webpack_public_path__ + "static/media/12.bc1471d0.png";